import React, {Suspense} from "react";
import ErrorBoundary from "../../utils/ErrorBoundary";

const LooksDistributor = React.lazy(/* webpackPrefetch: true */ () => import("./LooksDistributor"));

const LooksHandling: React.FC = () => {
  // LDP
  const lookDetailDiv = document.getElementById("shop-the-look-detail");
  // LLP
  const lookOverviewDiv = document.body.querySelector<HTMLElement>("#shop-the-look-overview > div");
  // PDP
  const lookRelatedDiv = document.getElementById("shop-the-look-detail-pdp");
  const itemId = document.body.querySelector<HTMLElement>("#AddToCartButtonRoot")?.dataset.itemid || null;

  if (!lookDetailDiv && !lookOverviewDiv && !(lookRelatedDiv && itemId)) {
    return null;
  }

  return (
    <ErrorBoundary fallback={null} occurrence="LookDetail">
      <Suspense fallback={null}>
        <LooksDistributor {...{lookDetailDiv, lookOverviewDiv, lookRelatedDiv, itemId}} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default LooksHandling;
